module.exports = __webpack_public_path__ + "static/media/ow2ll23.1b63a6ab.png";